import e from "./ghl-ui.es1516.js";
import o from "./ghl-ui.es1481.js";
function u(r) {
  o(1, arguments);
  var t = e(r);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
export {
  u as default
};
